import { useEffect, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'

import Cookies from 'js-cookie'
import config from '../../../config'

const LotteryShowImageModal = ({ isShow, onHide, orderId }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [dataListsImage, setDataListsImage] = useState([])

  const fetchImage = async (orderId) => {
    setIsLoading(true)
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v2/admin/lotteries/${orderId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json())
      setDataListsImage(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchImage(orderId)
  }, [orderId])

  return (
    <Modal show={isShow} onHide={onHide} size="xl" scrollable centered enforceFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title className="text-center">
          <span>
            รูปเลขลอตเตอรี่ {dataListsImage?.number} จำนวน {dataListsImage?.count} ใบ
          </span>
        </Modal.Title>
      </Modal.Header>
      {isLoading ? (
        <Modal.Body style={{ padding: '16px', display: 'flex', justifyContent: 'center' }}>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Modal.Body>
      ) : (
        <Modal.Body
          style={{
            padding: '16px',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            rowGap: '4px',
            columnGap: '4px',
          }}
        >
          {dataListsImage?.items.map((item) => (
            <div
              key={item.id}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <img src={`${item.imageUrl.slice(0, -4)}_M.jpg`} alt={`image-${item.id}`} />
            </div>
          ))}
        </Modal.Body>
      )}
    </Modal>
  )
}

export default LotteryShowImageModal
